<template>
  <layout-main-inner title="资质证书">
    <layout-card-wrap hasHeaderSlot
      v-loading="loading">
      <template slot="title">
        <create-certificate-btn :fetch="fetchList" />
      </template>
      <template slot="form">
        <el-input placeholder="请输入证书名称"
          v-model="config.certName"
          style="width: 200px">
          <el-button slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table border
        :data="list">
        <el-table-column label="证书名称"
          min-width="160">
          <template slot-scope="{row}">
            <link-route :link-to="`/certificate-detail?vendorId=${row.vendorId}&certId=${row.certId}`">
              {{row.certName}}
            </link-route>
          </template>
        </el-table-column>
        <el-table-column label="证书图片" min-width="300px">
          <template slot-scope="{row}">
            <image-list :fileList="row.certFile" />
          </template>
        </el-table-column>
         <el-table-column label="证书类型" min-width="120">
          <template slot-scope="{row}">
            <span v-if="row.regulatorId">
              <b>{{ row.regulatorName }}</b>颁发
            </span>
            <span v-else>企业自建</span>
            <!-- {{ row.regulatorId ? row.regulatorName + '颁发' : '企业自建' }} -->
          </template>
        </el-table-column>
        <el-table-column label="有效期"
          width="180">
          <template slot-scope="{row}">
            {{ row.certBeginTime | dateformat('YYYY-MM-DD')}} ~ {{ row.certEndTime | dateformat('YYYY-MM-DD')}}
          </template>
        </el-table-column>
        <el-table-column label="操作"
          width="80">
          <template slot-scope="{row}">
            <el-button type="text" :disabled="userPermission.ENT && !!row.regulatorId"
              @click="deleteCert(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination background
          @current-change="handleCurrentChange"
          :current-page.sync="config.pageNum"
          :page-size="config.pageSize"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import ImageList from '@/components/public/image-list.vue'
import CreateCertificateBtn from './busi/create-certificate-btn.vue'
import { mapState } from 'vuex'
export default {
  name: 'certificate-list',
  components: { ImageList, CreateCertificateBtn },
  props: {},
  data () {
    return {
      loading: false,
      config: { pageNum: 1, pageSize: 10, certName: '', vendorId: null },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission,
      query: state => state.common.query
    })
  },
  methods: {
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('certificate/getcertificates', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(item => {
            item.certFile = item.certFile.split(',').map(o => ({ url: o }))
            // item.regulatorId = '1233'
            return item
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deleteCert (row) {
      this.$confirm('此操作将永久删除该证书, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('certificate/deletecertificate', {
            payload: { certId: row.certId, vendorId: row.vendorId },
            success: (res) => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    }
  },
  created () {
    if (this.query) {
      this.config = { ...this.config, ...this.query }
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
